module.exports = __webpack_public_path__ + "static/media/co.cbbdb8aa.jpg";